<template>
  <div class="box one">
    <h2>예물맵 필터 노출 정보</h2>
    <p class="info-desc">
      예물맵 검색 노출을 위한 정보입니다. 입력하신 정보는 사용자가 매장을 검색할
      때 필터로 사용됩니다.
    </p>

    <div class="flexL">
      <p class="bold">편의</p>
      <div class="checkbox-group">
        <div class="filter-options">
          <el-checkbox v-model="form.amenities.parking">주차가능</el-checkbox>
          <el-checkbox v-model="form.reservationRequired">예약필수</el-checkbox>
        </div>
        <p class="filter-auto-hint">
          당일상담가능은 예약 설정에 따라 사용자 웹에 자동 반영됩니다.
        </p>
      </div>
    </div>

    <div class="flexL">
      <p class="bold">가격</p>
      <el-radio-group v-model="form.pricingPolicy">
        <el-radio label="">미선택</el-radio>
        <el-radio label="negotiable">유연한 가격 상담</el-radio>
        <el-radio label="fixed">정찰가 매장</el-radio>
      </el-radio-group>
    </div>

    <div class="flexL">
      <p class="bold">혜택</p>
      <el-checkbox-group
        :value="filterBenefits"
        @input="$emit('update:filter-benefits', $event)"
      >
        <el-checkbox
          v-for="option in benefitFilterOptions"
          :key="option.value"
          :label="option.value"
          >{{ option.label }}</el-checkbox
        >
      </el-checkbox-group>
    </div>

    <div class="flexL">
      <p class="bold">서비스</p>
      <div class="service-options">
        <el-checkbox-group v-model="form.services">
          <el-checkbox label="커스텀제작">맞춤제작</el-checkbox>
        </el-checkbox-group>
        <el-checkbox v-model="form.amenities.oneOnOne">1:1 상담</el-checkbox>
        <el-checkbox-group v-model="form.services">
          <el-checkbox label="AS">A/S 무상</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProviderBusinessFilterFields",
  props: {
    form: { type: Object, required: true },
    filterBenefits: { type: Array, default: () => [] },
    benefitFilterOptions: { type: Array, default: () => [] },
  },
};
</script>

<style
  src="./ProviderBusinessFilterFields.styles.scss"
  lang="scss"
  scoped
></style>
